import { Link } from "react-router-dom";
import { Tag } from "../base_components/tag";

export function PremiumButton() {
	return (
		<Link
			className="flex gap-2"
			to={{
				pathname: "/dashboard/premium",
				state: {
					prev_path: location.pathname,
				},
			}}
		>
			Premium
		</Link>
	);
}
